module.exports = __webpack_public_path__ + "static/media/share.67414b5c.png";